import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Suspended  from '@/components/wanhecup.vue'
import CompetitionIndex from '@/views/competition/index'
import Login from '@/views/login/index'
import Exam from '@/views/system/exam'
import ExamResult from '@/views/system/examresult'
import Member from '@/views/member/index'
import System from '@/views/system/index'
import {getInfo} from '@/utils/auth'
import Repair from '@/views/repair'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: '首页',
      component: Index
    },
    {
      path: '/competition/',
      name: '竞赛首页',
      component: CompetitionIndex
    },
    {
      path: '/login',
      name: '登陆',
      component: Login
    },
    {
      path: '/exam',
      name: 'Exam',
      component: Exam
    },
    {
      path: '/examrs',
      name: 'ExamResult',
      component: ExamResult
    },
    {
      path: '/member',
      name: 'Member',
      component: Member
    },
    {
      path: '/system',
      name: 'System',
      component: System
    },
    {
      path: '/repair',
      name: "repair",
      component: Repair
    },
    {
      path:'/Suspended',
      name:'Suspended',
      component:Suspended
    }
  ]
})
export default router

router.beforeEach((to,from,next) =>{
  //  if(to.path  == '/repair'){
  //    next()
  //  }else{
  //   next('/repair')
  //  }
   let userInfo = getInfo()
   if(!!userInfo){
     if((!userInfo.complete)&&to.path!='/member'){
       alert("请完善个人信息！")
       next('/member')
     }else{
       next()
     }
   }else{
     next()
   }
})



// WEBPACK FOOTER //
// ./src/router/index.js